import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const fetchAllFeedbacks = async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/feedback`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${sessionToken}`,
        },
    });

    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
};

const updateFeedbackStatus = async (id, status) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/feedback/${id}/status`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionToken}`,
        },
        body: JSON.stringify({ status }),
    });

    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
};

const deleteFeedback = async (id) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/feedback/${id}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${sessionToken}`,
        },
    });

    const data = await response.json();
    return data.session ? handleSessionExpire() : data;
};

export { fetchAllFeedbacks, updateFeedbackStatus, deleteFeedback };